export default __webpack_public_path__ + "static/media/school.989e6609.svg";